<template>
  <div class="Register">
    <!--header-->
    <HeaderNav title="立即注册"></HeaderNav>
    <!-- content -->
    <a-row class="content">
      <div class="register-wrapper">
        <!-- 表单 -->
        <div class="form">
          <!-- 笔img -->
          <!-- <img
            style="position: absolute; right: -70px; bottom: 30px"
            src="./images/pen.png"
            height="448"
            width="219"
          /> -->
          <div class="formItem">
            <a-form-model
              ref="form"
              :model="form"
              :rules="rules"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
            >
              <a-form-model-item ref="userName" label="用户名" prop="userName">
                <a-input v-model.trim="form.userName" placeholder="netid" />
              </a-form-model-item>
              <a-form-model-item ref="password" label="密码" prop="password">
                <a-popover
                  placement="rightTop"
                  trigger="click"
                  :visible="state.passwordLevelChecked"
                >
                  <template slot="content">
                    <div :style="{ width: '240px' }">
                      <div :class="['user-register', passwordLevelClass]">
                        强度：<span>{{ passwordLevelName }}</span>
                      </div>
                      <a-progress
                        :percent="state.percent"
                        :showInfo="false"
                        :strokeColor="passwordLevelColor"
                      />
                      <div style="margin-top: 10px">
                        <span>
                          请至少输入8个字符。请不要使用容易被猜到的密码。（需包含数字和字母）
                        </span>
                      </div>
                    </div>
                  </template>
                  <a-input
                    type="password"
                    v-model.trim="form.password"
                    autocomplete="false"
                    @change="passwordChange"
                    placeholder="至少 8 位密码，区分大小写"
                    @mouseout="state.passwordLevelChecked = false"
                    @mouseover="handlePasswordInputEvent"
                  />
                </a-popover>
              </a-form-model-item>
              <a-form-model-item ref="password" label="密码确认" prop="confirmPass">
                <a-input
                  type="password"
                  placeholder="请再次输入密码"
                  v-model.trim="form.confirmPass"
                />
              </a-form-model-item>
              <a-form-model-item ref="name" label="姓名" prop="name">
                <a-input v-model.trim="form.name" />
              </a-form-model-item>
              <a-form-model-item ref="emailAddress" label="邮箱地址" prop="emailAddress">
                <a-input
                  v-model.trim="form.emailAddress"
                  placeholder="中山大学内部邮箱"
                />
              </a-form-model-item>
              <a-form-model-item ref="department" label="所属学院" prop="department">
                <a-input v-model.trim="form.department" />
              </a-form-model-item>
              <a-form-model-item ref="phoneNumber" label="手机号码" prop="phoneNumber">
                <a-input v-model.trim="form.phoneNumber" />
              </a-form-model-item>
              <a-form-model-item
                ref="captchaResponse"
                label="验证码"
                prop="captchaResponse"
              >
                <div class="flex">
                  <a-input v-model.trim="form.captchaResponse" />
                  <a-button
                    :disabled="state.smsSendBtn"
                    style="margin-left: 10px"
                    @click.stop.prevent="ShowGraphCertificateModal"
                    v-text="(!state.smsSendBtn && '获取验证码') || state.time + ' s'"
                  ></a-button>
                </div>
              </a-form-model-item>
            </a-form-model>
            <a-col class="center">
              <a-button type="primary" @click="submit" @loading="loading"
                >提交审核</a-button
              >
            </a-col>
          </div>
        </div>
      </div>
    </a-row>
    <!-- 底部 -->
    <FooterNav class="footerNav"></FooterNav>
    <!-- 图形验证弹窗 -->
    <GraphCertificateModal ref="GraphCertificateModal" :securityUserCenterUrl="securityUserCenterUrl" :graphCertificateModalVisible="graphCertificateModalVisible" @cancel="graphCertificateModalCancel" @ok="graphCertificateModalOk"></GraphCertificateModal>
  </div>
</template>

<script>
// import axios from 'axios'
import GraphCertificateModal from '@/components/GraphCertificateModal'
import { SqliteUserAuditInsert, SqliteBacklogInsert } from '@/api/Sqlite'
import {
  userCenterGetAll,
  userCenterALogin,
  userCenterValidNameOrEmail,
  userCenterRegister,
  userCenterSendCode
} from '@/api/user'
import HeaderNav from '@/components/HeaderNav'
import FooterNav from '@/components/FooterNav'
import { A_TENANT_ID, A_ACCESS_TOKEN } from '@/store/mutation-types'
import { setWindowGlobalUrl } from '@/utils/axios'
const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}
export default {
  components: { HeaderNav, FooterNav, GraphCertificateModal },
  props: {
    axios: Function,
    TENANT_ID: { // 平台ID
      type: Number,
      default: 2198
    },
    A_Tenant_Id: {
      type: Number,
      default: 1 // 采购人
    },
    companyData: {
      type: Object,
      default: () => {
        return {
          companyName: '中山大学',
          companyNo: '121000004558631445',
          companyTel: '020-84110285',
          area: '广东省',
          area2: '广州市'
        }
      }
    }
  },
  computed: {
    // 是否重新发起审核
    ifReRegister () {
      return this.$route.params.userName
    },
    platform () {
      return this.$route.params.platform
    },
    passwordLevelClass () {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName () {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor () {
      return levelColor[this.state.passwordLevel]
    },
    isMobile () {
      const flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
      return flag
    }
  },
  data () {
    return {
      securityUserCenterUrl: null,
      graphCertificateModalVisible: false, // 图形验证弹窗
      loading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 15 },
      validNameOrEmailTimeout: null,
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'change' }],
        captchaResponse: [{ required: true, message: '请输入验证码', trigger: 'change' }],
        department: [{ required: true, message: '请输入所属学院', trigger: 'change' }],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'change' },
          { validator: this.handleValidNameOrEmail }
        ],
        emailAddress: [
          { required: true, message: '请输入邮箱地址', trigger: 'change' },
          { type: 'email', message: '请输入正确的邮箱地址' },
          { validator: this.handleValidNameOrEmail }
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入有效的手机号' }
        ],
        // roleNames: [{ required: true, message: "请选择角色", trigger: "change" }],
        password: [
          {
            required: true,
            message: '请确认密码',
            trigger: 'change'
          },
          { validator: this.handlePasswordLevel }
        ],
        confirmPass: [
          { required: true, message: '请再次输入密码', trigger: 'change' },
          { validator: this.handleConfirmPass }
        ]
      },
      selections: {
        role: []
      },
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      form: {
        userName: '',
        password: '',
        confirmPass: '',
        name: '',
        emailAddress: '',
        phoneNumber: '',
        captchaResponse: ''
      },
      currentAccountMsg: { // 当前账号相关信息
        A_TENANT_ID: 1, // 角色id - 采购人
        A_ACCESS_TOKEN: '', // atoken
        dotnetResult_accessToken: ''
      }
    }
  },
  async created () {
    if (this.$route.params.userName) {
      this.inifForm()
    }
    if (window.urlConfig && window.urlConfig.requests && window.urlConfig.requests.middlewareUrl) {
      this.securityUserCenterUrl = window.urlConfig.requests.middlewareUrl + '/security/userCenter'
    } else {
      await setWindowGlobalUrl()
      this.securityUserCenterUrl = window.urlConfig.requests.middlewareUrl + '/security/userCenter'
    }
  },
  methods: {
    graphCertificateModalCancel () {
      this.graphCertificateModalVisible = false
    },
    graphCertificateModalOk (graphCode) {
      this.getCaptchaByPhoneNumber(graphCode)
    },
    // 显示图形验证弹窗
    ShowGraphCertificateModal () {
      this.$refs.form.validateField('phoneNumber', async (err) => {
        console.log(err)
        if (!err) {
          this.graphCertificateModalVisible = true
          this.$nextTick(() => {
            console.log(this.$refs.GraphCertificateModal)
            this.$refs.GraphCertificateModal.setPhoneNumber(this.form.phoneNumber)
          })
        } else {
          this.$message.error('请按要求填写手机号码')
        }
      })
    },
    // 重新发起注册审核
    async inifForm () {
      const aToken = this.$ls.get(A_ACCESS_TOKEN)
      const tenant = this.$ls.get(A_TENANT_ID) || ''
      const headers = {
        'Abp.TenantId': tenant,
        Authorization: `Bearer ${aToken}`
      }
      const userName = this.$route.params.userName
      const params = {
        filter: `userName = "${userName}"`,
        IsActive: true
      }
      const res = await userCenterGetAll(params, headers)
      const dataForm = res.data.result.items[0]
      this.form = {
        userName: dataForm?.userName,
        password: '',
        confirmPass: '',
        department: dataForm?.department,
        name: dataForm?.surname,
        emailAddress: dataForm?.emailAddress,
        phoneNumber: dataForm?.phoneNumber,
        captchaResponse: ''
      }
    },
    // 获取验证码
    async getRegCode (data) {
      const result = await userCenterSendCode(data)
      return result
    },
    passwordChange () {
      const value = this.form.password
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
    },
    handlePasswordInputEvent () {
      if (!this.isMobile) {
        /* 当前设备是电脑 */
        this.state.passwordLevelChecked = true
        return
      }
      this.state.passwordLevelChecked = false
    },
    // --------------------表单校验-----------------------
    async handleValidNameOrEmail (rule, value, callback) {
      let result = {}
      if (value) {
        result = await this.validNameOrEmail(value, this.A_Tenant_Id)
        console.log('result', result)
        if (result?.error) {
          callback(new Error(result?.error?.message))
        }
        if (result?.success) {
          callback()
        }
      }
    },
    handlePasswordLevel (rule, value, callback) {
      if (value.length < 8) {
        callback(new Error('密码长度不够'))
      } else {
        if (this.state.passwordLevel >= 2) {
          if (this.state.passwordLevel >= 3) {
            this.state.percent = 100
          }
          callback()
        } else {
          if (this.state.passwordLevel === 0) {
            this.state.percent = 10
          }
          callback(new Error('密码强度不够'))
        }
      }
    },
    handleConfirmPass (rule, value, callback) {
      if (!value.trim()) {
        callback(new Error('请再次输入密码'))
      }
      if (this.form.password !== value) {
        callback(new Error('两次密码输入不一致'))
      }
      callback()
    },
    // --------------------表单校验-----------------------
    getCaptchaByPhoneNumber (graphCode) {
      const { state, $message, $notification } = this
      this.$refs.form.validateField('phoneNumber', async (errorMessage) => {
        if (!errorMessage) {
          if (!graphCode) {
            this.$message.error('请先获取图形验证码')
            return
          }
          const hide = $message.loading('验证码发送中..', 0)
          const parameter = {
            captcha: graphCode,
            phoneNumber: this.form.phoneNumber,
            action: 'Register'
          }
          let interval = null
          try {
            let res = await this.getRegCode(parameter)
            console.log(res)
            if (res.success) {
              res = res.result
              if (res.result.message === 'SUCCESS') {
                setTimeout(hide, 1000)
                $notification.success({
                  message: '提示',
                  description: '验证码已发送，请及时查看',
                  duration: 4
                })
                state.smsSendBtn = true
                state.time = 60
                interval = setInterval(() => {
                  if (state.time === 0) {
                    clearInterval(interval)
                    state.smsSendBtn = false
                    state.time = 60
                    return
                  }
                  state.time--
                }, 1000)
                this.graphCertificateModalVisible = false
              } else {
                console.log(res.result)
                this.$message.error(res.result.message)
              }
            } else {
              this.$message.error(res.error.message)
            }
            setTimeout(hide, 1)
          } catch (e) {
            console.log(e)
            setTimeout(hide, 1)
            clearInterval(interval)
            state.time = 60
            state.smsSendBtn = false
            this.$notification.error({
              message: '错误',
              description: '图形验证码错误',
              duration: 4
            })
          }
        }
      })
    },
    async validNameOrEmail (usernameOrEmailAddress, tenantId) {
      let res = { success: true }
      const data = await userCenterValidNameOrEmail({
        usernameOrEmailAddress,
        tenantId
      })
      if (data?.success) {
        res = {
          success: data.success
        }
      } else {
        res = {
          error: data.error
        }
      }
      return res
    },
    async submitUserData (fromData) {
      // 注册账号
      let parameter = {
        name: '',
        surname: fromData.name,
        userName: '',
        emailAddress: '',
        password: '',
        phoneNumber: '',
        captchaResponse: '', // 验证码
        isActive: true,
        custormerManager: '', // 客户经理
        department: '', // 所属部门
        registerEntry: this.TENANT_ID + '', // 注册来源
        companyInput: {
          companyNo: this.companyData.companyNo,
          companyName: this.companyData.companyName,
          companyTel: this.companyData.companyTel,
          area: this.companyData.area,
          area2: this.companyData.area2,
          companyType: ''
        }
      }
      parameter = Object.assign(parameter, fromData)
      const headers = {
        'Content-Type': 'application/json; charset=utf-8',
        'Abp.TenantId': this.A_Tenant_Id
      }
      const res = await userCenterRegister(
        parameter,
        headers
      )
      console.log(res)
      return {
        result: res.result,
        success: res.success
      }
    },
    // 提交用户审核
    async submitUserAudit (formData, userId) {
      /**
       * // TODO - companyId、companyName暂时写死
       * 因为注册返回的数据有问题
       * 等注册接口重写了再换
       */
      const parameter = {
        auditStatus: null,
        companyId: '338C79F2-5BD3-4B4D-D85E-08D84955409B',
        companyName: '中山大学',
        reason: '',
        remark: '发起审核',
        tenantId: this.A_Tenant_Id, // a的角色-采购人 1
        type: this.TENANT_ID, // 平台的id
        userId, // TODO - 这里也应该补上Auser_Id
        userName: formData.userName
      }
      let aToken, TenantId
      if (this.ifReRegister) { // 重新发起注册（已登陆，有信息）
        aToken = this.$ls.get(A_ACCESS_TOKEN)
        TenantId = this.$ls.get(A_TENANT_ID)
      } else {
        aToken = this.currentAccountMsg.dotnetResult_accessToken
        TenantId = this.currentAccountMsg.A_TENANT_ID
      }
      const headers = {
        'Abp.TenantId': TenantId,
        Authorization: `Bearer ${aToken}`
      }
      await SqliteUserAuditInsert(parameter, headers)
    },
    // 模拟登录，获取atoken
    async simulateLoginForAtoken ({ username, password }) {
      const headers = {
        'Abp.TenantId': this.A_Tenant_Id
      }
      const { result } = await userCenterALogin({
        userNameOrEmailAddress: username,
        password
      }, headers)
      console.log(result)
      // debugger
      return {
        A_ACCESS_TOKEN: result?.accessToken, // atoken
        dotnetResult_accessToken: result?.accessToken
      }
    },
    // 提交代办
    async submitBacklog (userId) {
      const params = {
        associatedId: userId,
        description: '',
        platformId: this.TENANT_ID, // 平台id
        status: '0', // 代表状态， 0代办，1已办
        tenantId: this.A_Tenant_Id, // 租户id
        type: 'userAudit'
      }
      // const aToken = this.$ls.get(A_ACCESS_TOKEN)
      // const tenant = this.$ls.get(A_TENANT_ID)
      let aToken, TenantId
      if (this.ifReRegister) { // 重新发起注册（已登陆，有信息）
        aToken = this.$ls.get(A_ACCESS_TOKEN)
        TenantId = this.$ls.get(A_TENANT_ID)
      } else {
        aToken = this.currentAccountMsg.dotnetResult_accessToken
        TenantId = this.currentAccountMsg.A_TENANT_ID
      }
      const headers = {
        'Abp.TenantId': TenantId,
        Authorization: `Bearer ${aToken}`
      }
      console.log('SqliteBacklogInsert', params, headers)
      console.log('SqliteBacklogInsert2', headers.Authorization)
      // debugger
      const res = await SqliteBacklogInsert(params, headers)
      return res
    },
    async submit () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            this.$spin.show('注册信息提交中，请稍后。。。')
            const { success, result } = await this.submitUserData(this.form)
            if (success) {
              // 模拟登录，获取atoken
              // eslint-disable-next-line camelcase
              const { A_ACCESS_TOKEN, dotnetResult_accessToken } = await this.simulateLoginForAtoken({
                username: this.form.userName,
                password: this.form.password
              })
              this.currentAccountMsg.A_ACCESS_TOKEN = A_ACCESS_TOKEN
              // eslint-disable-next-line camelcase
              this.currentAccountMsg.dotnetResult_accessToken = dotnetResult_accessToken
              console.log(this.currentAccountMsg)
              // debugger
            } else {
              throw new Error(result.msg)
            }
            await this.submitUserAudit(this.form, result.msg)
            await this.submitBacklog(result.msg)
            await this.$message.success('提交成功')
            this.$spin.hide()
            this.loading = false
            this.$router.push({
              name: 'RegisterSuccess',
              params: { platform: this.platform }
            })
          } catch (error) {
            console.log(error)
            this.$message.error(error.message || '提交失败')
            this.$spin.hide()
            this.loading = false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.success {
  color: #52c41a;
}
.warning {
  color: #faad14;
}
.error {
  color: #f5222d;
}
.center {
  margin: 0 auto;
  text-align: center;
}
.flex {
  display: flex;
  justify-content: space-between;
}
@labelColor: #fff;

.Register {
  min-height: 700px;
  position: relative;
  min-width: 600px;
  height: 100vh;
}
.content {
  background: #f7f7f8;
  padding: 20px;
  .register-wrapper {
    // background: url("./images/bg-register.png") top no-repeat,
    //   -webkit-linear-gradient(top left, @labelColor, #c5e9ff);
    // min-height: 846px;
    // min-width: 90%;
    // padding: 50px;
    .form {
      box-shadow: 0 1px 10px 0 rgb(190, 207, 228, 0.15);
      position: relative;
      background-color: @labelColor;
      padding: 40px;
      margin: 0 auto;
      width: 80%;
      min-height: 650px;
      max-width: 1300px;
      .formItem {
        margin: 0 auto;
        width: 70%;
        max-width: 700px;
      }
    }
  }
}
</style>
